import defaultAvatar from 'assets/images/voice/avatars/default.png';
import i18next from 'i18next';
import { DeepgramTranscriptionLanguageCode, TranscriptionConfiguration } from 'shared/interfaces/Transcription';
import { VoiceAge, VoiceConfiguration, VoiceGender } from 'shared/interfaces/Voice';

export const DEFAULT_TRANSCRIPTION_CONFIG: TranscriptionConfiguration = {
  provider: 'openai'
};

export const DEFAULT_VOICE_CONFIG: VoiceConfiguration = {
  name: 'Amy',
  voiceId: 'alloy',
  provider: 'openai',
  language: 'multi',
  gender: 'female',
  age: 'young',
  previewUrl: '', // Preview URL will be set once the default voice is fetched
  avatarUrl: defaultAvatar
};

export type AllOptions = 'all';

type VoiceGenderOption = { value: AllOptions | VoiceGender; label: string };
export const VOICE_GENDER_OPTIONS: VoiceGenderOption[] = [
  { value: 'all', label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.GENDER.ALL_GENDERS_LABEL') },
  { value: 'male', label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.GENDER.MALE_LABEL') },
  { value: 'female', label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.GENDER.FEMALE_LABEL') }
];

type VoiceAgeOption = { value: AllOptions | VoiceAge; label: string };
export const VOICE_AGE_OPTIONS: VoiceAgeOption[] = [
  { value: 'all', label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.AGE.ALL_AGES_LABEL') },
  { value: 'young', label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.AGE.YOUNG_LABEL') },
  { value: 'middle-aged', label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.AGE.MIDDLE_AGED_LABEL') }
];

type VoiceLanguageOption = { value: AllOptions | DeepgramTranscriptionLanguageCode; label: string };
export const VOICE_LANGUAGE_OPTIONS: VoiceLanguageOption[] = [
  { value: 'all', label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.ALL_LANGUAGES_LABEL') },
  {
    value: 'en',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.ENGLISH_LABEL')
  },
  {
    value: 'zh',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.CHINESE_LABEL')
  },
  {
    value: 'cs',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.CZECH_LABEL')
  },
  {
    value: 'da',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.DANISH_LABEL')
  },
  {
    value: 'nl',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.DUTCH_LABEL')
  },
  {
    value: 'fr',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.FRENCH_LABEL')
  },
  {
    value: 'de',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.GERMAN_LABEL')
  },
  {
    value: 'el',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.GREEK_LABEL')
  },
  {
    value: 'hi',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.HINDI_LABEL')
  },
  {
    value: 'it',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.ITALIAN_LABEL')
  },
  {
    value: 'ja',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.JAPANESE_LABEL')
  },
  {
    value: 'ko',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.KOREAN_LABEL')
  },
  {
    value: 'no',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.NORWEGIAN_LABEL')
  },
  {
    value: 'pt',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.PORTUGUESE_LABEL')
  },
  {
    value: 'ru',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.RUSSIAN_LABEL')
  },
  {
    value: 'es',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.SPANISH_LABEL')
  },
  {
    value: 'sv',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.SWEDISH_LABEL')
  },
  {
    value: 'tr',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.TURKISH_LABEL')
  },
  {
    value: 'vi',
    label: i18next.t('SMART_ASSISTANT.PHONE_AGENT_BASICS_SECTION.VOICE.LANGUAGE.VIETNAMESE_LABEL')
  }
];

export const DEFAULT_VOICE_MODEL = 'eleven_turbo_v2_5';
export const DEFAULT_VOICE_PROVIDER = '11labs';
export const DEFAULT_SILENCE_TIMEOUT_SECONDS = 10;
export const DEFAULT_MAX_CALL_DURATION_SECONDS = 300;
export const APPOINTMENT_SCHEDULING_TOOL_GUIDE_URL = 'https://docs.droxy.ai/documentation/agents/phone/appointments';
